<div class="menu" *ngIf="editMode">
  <div class="block">
    <button type="button" class="edit" (click)="edit(data?.id)"></button>
    <button type="button" class="{{data?.isPublished?'unpublish':'publish'}}" (click)="show(data?.id, !data?.isPublished)"></button>
    <button type="button" class="delete" (click)="delete(data?.id)"></button>
  </div>
</div>
